module.exports = require("memoizee");


//////////////////
// WEBPACK FOOTER
// external "memoizee"
// module id = 479
// module chunks = 0